<template>
    <v-dialog v-model="viewOps.dialog" max-width="550px">
        <v-card>
            <v-card-title>
                <v-row align="center">
                    <v-col cols="10">
                        <span>View Task</span>
                    </v-col>
                    <v-col cols="2">
                        <div class="float-right">
                            <CustomButton
                                btnIcon="mdi-close"
                                tooltipMsg="Close"
                                @click="hideDialog"
                            />
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-divider />

            <v-card-text class="px-4">
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer" v-slot="{}">
                            <v-form>
                                <v-row dense>
                                    <v-col>
                                        <CustomLabel
                                            for="Name"
                                            label="Name"
                                            required
                                        />
                                        <CustomTextField
                                            id="name"
                                            inputPlaceholder="Name"
                                            :inputValue="task.name"
                                            validationName="name"
                                            validationRules="required"
                                            @input="
                                                updateForm($event, 'task.name')
                                            "
                                        />
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <CustomButton
                                            btnLabel="Cancel"
                                            tooltipMsg="Cancel"
                                            @click="hideDialog"
                                        />
                                        <CustomButton
                                            btnColour="primary"
                                            :btnIsLoading="updateOps.isLoading"
                                            btnLabel="Save"
                                            tooltipMsg="Save"
                                            @click="updateItem(task)"
                                        />
                                    </v-col>
                                </v-row>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Field cannot be empty.",
});

export default {
    computed: {
        ...mapState("tasksAdminMgmt", ["task", "updateOps", "viewOps"]),
    },
    data: () => ({}),
    methods: {
        hideDialog() {
            this.$store.commit("tasksAdminMgmt/HIDE_VIEW_OPS_DIALOG");
            this.$store.commit("tasksAdminMgmt/FLUSH_TASK");
        },
        updateForm(event, form) {
            if (event instanceof InputEvent) {
                this.$store.commit("tasksAdminMgmt/UPDATE_FORM", {
                    payload: {
                        form: form,
                        value: event.target.value,
                    },
                });
                return;
            } else if (
                event instanceof String ||
                typeof event == "boolean" ||
                typeof event == "number" ||
                typeof event == "string"
            ) {
                this.$store.commit("tasksAdminMgmt/UPDATE_FORM", {
                    payload: {
                        form: form,
                        value: event,
                    },
                });
                return;
            } else {
                return;
            }
        },
        async updateItem(payload) {
            let valid = this.$refs.observer.validate();

            if (!valid) {
                return;
            }

            let response = await this.$store.dispatch(
                "tasksAdminMgmt/updateItem",
                {
                    id: payload.id,
                    task: {
                        name: payload.name,
                    },
                }
            );

            if (response) {
                this.$refs.observer.reset();
            }
        },
    },
    name: "DialogTaskView",
    // Lifecycle hooks.
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
};
</script>
